import { render, staticRenderFns } from "./ProjectCardGrid.vue?vue&type=template&id=37f6397d&scoped=true"
import script from "./ProjectCardGrid.vue?vue&type=script&lang=js"
export * from "./ProjectCardGrid.vue?vue&type=script&lang=js"
import style0 from "./ProjectCardGrid.vue?vue&type=style&index=0&id=37f6397d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6397d",
  null
  
)

export default component.exports